module.exports = __webpack_public_path__ + "img/animation7.f940805b.png";